import { Component, DestroyRef, effect, inject } from '@angular/core';
import { DesyNavModule } from 'desy-angular';
import { Notice } from '../../services/notices/models/notices.model';
import { NoticesService } from '../../services/notices/notices.service';
import { ScreenHandlerService } from '../../services/screen-handler/screen-handler.service';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-notices',
  imports: [DesyNavModule],
  templateUrl: './notices.component.html'
})
export class NoticesComponent {
  private readonly noticesService = inject(NoticesService);
  protected readonly screenHandlerService = inject(ScreenHandlerService);
  private readonly destroyRef = inject(DestroyRef);

  protected notices: Notice[] = [];

  constructor() {
    effect(() => {
      if (AuthenticationService.User()) {
        this.noticesService.notices.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((notices) => {
          this.notices = notices;
        });
      }
    });
  }

  onNotificationChange(index: number, isOpen: boolean): void {
    if (!isOpen) {
      this.noticesService.close(index);
    }
  }
}
